import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/core'
import * as React from 'react'

type DropdownItem = { title: string; onClick?: () => void }

type DropdownMenuProps = {
  menuItems: DropdownItem[]
  title: string
  bg?: string
  icon?: React.ReactElement
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ menuItems, title, icon, bg }) => {
  return (
    <Menu>
      {({ isOpen }) => (
        <React.Fragment>
          {/* 
          // @ts-ignore - complains about rightIcon prop, but it exists */}
          <MenuButton as={Button} rightIcon={isOpen ? 'chevron-up' : 'chevron-down'} bg={bg}>
            {icon ? icon : title}
          </MenuButton>
          <MenuList>
            {menuItems.map(({ title, onClick }) => (
              <MenuItem key={title} onClick={onClick}>
                {title}
              </MenuItem>
            ))}
          </MenuList>
        </React.Fragment>
      )}
    </Menu>
  )
}

export default DropdownMenu
